import React from 'react'
import { Paper, Typography, Link as MuiLink, Box } from '@mui/material'
import FormatQuoteIcon from '@mui/icons-material/FormatQuote'

interface ExpertCalloutProps {
  quote: string
  expertName: string
  credentials: string
  linkUrl: string
  linkText: string
}

const ExpertCallout: React.FC<ExpertCalloutProps> = ({
  quote,
  expertName,
  credentials,
  linkUrl,
  linkText,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, md: 4 },
        my: 4,
        bgcolor: 'background.default',
        border: '1px solid',
        borderColor: 'divider',
        borderLeft: 4,
        borderLeftColor: 'secondary.main',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <FormatQuoteIcon sx={{ color: 'secondary.main', fontSize: '2rem' }} />
      </Box>
      <Typography
        variant="body1"
        sx={{ fontStyle: 'italic', mb: 2, lineHeight: 1.8 }}
      >
        &ldquo;{quote}&rdquo;
      </Typography>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {expertName}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {credentials}
      </Typography>
      <MuiLink
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ fontWeight: 600 }}
      >
        {linkText} →
      </MuiLink>
    </Paper>
  )
}

export default ExpertCallout
